import React from "react";
import { Helmet } from "react-helmet-async";
import brand from "../content/brand";

const Meta = ({ title, description }) => {
  const full = title ? `${title} · ${brand.name}` : `${brand.name} — ${brand.oneLiner}`;
  const d = description || brand.pitch;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default Meta;
